/**
 * ============================================================================
 * CHAT AGENT API — accessor for POST /generateEmbedUrlForChatAgent.
 * ============================================================================
 *
 * LAYER: accessor. The ONLY transport for the WBR Agent chat embed: it POSTs
 * the agent name + alias and returns the signed QuickSight embed URL the UI
 * renders in an iframe. The service authorizes the caller (Midway) and proxies
 * the ADSInsights embed API, so this accessor carries no auth logic of its own
 * beyond the shared Midway/SigV4 path in ReportingApiClient.
 *
 * Cache policy (retention) is NOT here — it belongs to the RTK endpoint
 * (features/api/chatAgentApi.ts).
 */

import { ReportingApiClient } from 'src/accessors/ReportingApiClient';
import {
  GenerateEmbedUrlForChatAgentInput,
  GenerateEmbedUrlForChatAgentOutput,
} from 'src/types/chatAgentApi.types';

class ChatAgentApiClient extends ReportingApiClient {
  public async generateEmbedUrl(
    input: GenerateEmbedUrlForChatAgentInput,
  ): Promise<GenerateEmbedUrlForChatAgentOutput> {
    return this.post<GenerateEmbedUrlForChatAgentOutput>(
      '/generateEmbedUrlForChatAgent',
      input,
    );
  }
}

/** Singleton (portal convention): one shared instance app-wide. */
export const ChatAgentApi = new ChatAgentApiClient();
